import React from "react";
import { FiArrowLeft } from "react-icons/fi";
import styles from "./containerHeader.module.css";
import IconButton from "common/IconButton";

const ContainerHeader = ({
  label = "",
  buttonLabel = null,
  buttonFunction = null,
  showAddButton = true,
  showBackButton = false,
  onBackClick = null,
  icon = "add",
}) => {
  return (
    <>
      <div className={styles.TicketHeader}>
        <div className={styles.titleGroup}>
          {showBackButton && (
            <button
              type="button"
              className={styles.backIconButton}
              onClick={onBackClick}
              aria-label="Go back"
              title="Back"
            >
              <FiArrowLeft size={18} />
            </button>
          )}
          <div className={styles.labelName}>{label}</div>
        </div>

        {showAddButton && (
          <IconButton
            icon={icon}
            buttonLabel={buttonLabel}
            buttonFunction={buttonFunction}
            label={label}
          />
        )}
      </div>
    </>
  );
};

export default React.memo(ContainerHeader);
